import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BarChart2 } from 'lucide-react';

/**
 * 1) Definimos un botón con estilos personalizados,
 *    usando Material UI + lucide-react para el ícono.
 */
const StyledActionButton = styled(Button)(({ theme }) => {
  const isWallpaperMode = theme.palette.actualMode === 'wallpaper';

  return {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(3),
    backgroundColor: isWallpaperMode ? '#FFFFFF' : '#007BFE',
    color: isWallpaperMode ? '#000000' : '#FFFFFF',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    textTransform: 'none',
    boxShadow: 'none',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: isWallpaperMode ? 'rgba(255, 255, 255, 0.85)' : '#0056b3',
      transform: 'translateY(-1px)',
      boxShadow: 'none'
    }
  };
});

/**
 * 2) El componente recibe un `onClick` para
 *    ejecutar la acción de "ver análisis detallado".
 */
const ViewDetailedButton = ({ onClick }) => {
  return (
    <StyledActionButton onClick={onClick}>
      <BarChart2 size={16} />
      Ver Análisis Detallado
    </StyledActionButton>
  );
};

export default ViewDetailedButton;
